import { useState, useCallback } from 'react';

/**
 * API istekleri için custom hook
 * Duplicate loading/error handling kodlarını azaltır
 */
export const useApiRequest = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const makeRequest = useCallback(async (apiCall, options = {}) => {
    const { 
      showLoading = true, 
      clearError = true,
      onSuccess,
      onError 
    } = options;

    try {
      if (showLoading) setLoading(true);
      if (clearError) setError(null);
      
      const response = await apiCall();
      
      if (onSuccess) onSuccess(response);
      return response;
    } catch (err) {
      const errorMessage = err.message || 'Bir hata oluştu';
      setError(errorMessage);
      
      if (onError) onError(err);
      throw err;
    } finally {
      if (showLoading) setLoading(false);
    }
  }, []);

  const clearError = useCallback(() => {
    setError(null);
  }, []);

  return { 
    loading, 
    error, 
    makeRequest, 
    clearError 
  };
};

/**
 * Form state management için custom hook
 * Duplicate form handling kodlarını azaltır
 */
export const useFormState = (initialState) => {
  const [formData, setFormData] = useState(initialState);
  const [errors, setErrors] = useState({});

  const updateField = useCallback((name, value) => {
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    
    // Field error'ını temizle
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: null
      }));
    }
  }, [errors]);

  const updateMultipleFields = useCallback((updates) => {
    setFormData(prev => ({
      ...prev,
      ...updates
    }));
  }, []);

  const setFieldError = useCallback((name, error) => {
    setErrors(prev => ({
      ...prev,
      [name]: error
    }));
  }, []);

  const clearErrors = useCallback(() => {
    setErrors({});
  }, []);

  const resetForm = useCallback(() => {
    setFormData(initialState);
    setErrors({});
  }, [initialState]);

  return {
    formData,
    setFormData,
    errors,
    updateField,
    updateMultipleFields,
    setFieldError,
    clearErrors,
    resetForm
  };
};
